import styled from '@emotion/styled';
import React from 'react';
import Text04Img from 'ui/images/article/text_04.svg';

const DescriptionText = styled.p`
    font-family: 'Zen Kaku Gothic Antique', -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 0.96rem;
    line-height: 160%;
    letter-spacing: 0.8px;
    color: #1e4e66;
    margin: 0;
`;

const HighlightText = styled.span`
    font-weight: 700;
    color: #ee793f;
    background-color: #fffbc9;
`;

const ContentWrapper = styled.div`
    position: relative;
    width: 90%;
    margin-top: 40px;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    justify-content: center;
    cursor: pointer;
`;

export const MaForBeginnerDerail_3_2: React.FC = () => {
    return (
        <>
            <DescriptionText>
                M&Aにおけるトラブルの多くは、<HighlightText>情報の非対称性と契約内容の不十分さ</HighlightText>
                から生じます。例えば、売り手が会社のリスクを十分に開示していなかった場合、成約後に買い手から損害賠償を請求されることがあります。また、仲介手数料や契約解除条件について事前に確認していないと、予想外の費用負担が発生するケースもあります。さらに、担当者の経験不足により、買い手候補の選定や交渉が難航することもあります。こうしたトラブルを防ぐには、、
                <HighlightText>契約内容を十分に理解し、信頼できる仲介会社を選ぶことが不可欠</HighlightText>です。
            </DescriptionText>
            <ContentWrapper>
                <img src={Text04Img} alt="M&Aの流れ" style={{ width: '100%', height: 'auto' }} />
            </ContentWrapper>
        </>
    );
};
